/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'
/**
 * Import
 * - Actions
 */
import { setStep04c, setStep04cRenewals, getQuoteVariation, resetQuotes } from '../../../../../actions'
/**
 * Import
 * - Page component
 */
import Step04 from '../components/Step04'

const mapStateToProps = (state: RootState, props: any) => {

    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
        riskLocations: get(state.quote, 'riskLocations.response'),
        isDealersStock: true,
        isMuseums: false,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep04c: setStep04c,
        setStep04cRenewals: setStep04cRenewals,
        getQuoteVariation,
        resetQuotes: resetQuotes,
    }
)(Step04)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/EditQuote/containers/Step04d.tsx